import React from "react";
import { OptionCard } from "components";

const LengthField = ({ options, value, onChange }) => (
  <div className="cg-opt-grid">
    {options.map((o) => (
      <OptionCard
        key={o.id}
        meta={o.meta}
        name={o.name}
        detailLines={o.detailLines}
        selected={value === o.id}
        onSelect={() => onChange(o.id)}
      />
    ))}
  </div>
);

export default LengthField;
